import Vue from 'vue';
import { mapState } from 'vuex';
import tinycolor from 'tinycolor2';
import Greview from '@/components/global/DinamicBlocks/Greview.vue';
import Cookies from 'universal-cookie';

export default {
  data() {
    return {
      isCookieModalOpen: false,
      isCookieBannerVisible: false
    }
  },
  methods: {
    cookieLaw() {
      const cookies = new Cookies();

      if (!cookies.get('cookie_accepted')) {
        this.isCookieBannerVisible = true;
      } else {
        // Load and apply saved preferences
        const savedPreferences = cookies.get('cookie_preferences');
        if (savedPreferences) {
          this.configureConsent(savedPreferences);
        }
      }
    },

    showCookiePreferences() {
      // Allow users to change their cookie preferences after acceptance
      this.showCookieCustomizationModal();
    },

    hideCookieBanner() {
      this.isCookieBannerVisible = false;
    },

    showCookieCustomizationModal() {
      this.isCookieModalOpen = true;
    },

    closeCookieModal() {
      this.isCookieModalOpen = false;
    },

	configureConsent(preferences) {
		// Update consent through Analytics Manager (GTM is now a provider)
		if (typeof window !== 'undefined' && window.$analytics) {
			window.$analytics.updateConsent(preferences);
		}

		// Store consent globally for provider access
		if (typeof window !== 'undefined') {
			window.analyticsConsent = preferences;
		}

		console.log('[Cookie Consent] Preferences updated via Analytics Manager:', preferences);
	},

    onCookiePreferencesSaved(preferences) {
      const cookies = new Cookies();

      // Update saved preferences in cookies
      cookies.set('cookie_preferences', preferences, {
        path: '/',
        maxAge: 6 * 30 * 24 * 60 * 60,
        sameSite: 'lax'
      });

      // Configure consent for all tracking systems
	  this.configureConsent(preferences);
      this.hideCookieBanner();
      this.closeCookieModal();

      console.log('[Cookie Consent] Preferences updated:', preferences);
    },

    onCookieBannerAccepted(preferences) {
      const cookies = new Cookies();

      // Save to cookies (not session) for persistence
      cookies.set('cookie_accepted', true, {
        path: '/',
        maxAge: 6 * 30 * 24 * 60 * 60, // 1 year
        sameSite: 'lax'
      });
      cookies.set('cookie_preferences', preferences, {
        path: '/',
        maxAge: 6 * 30 * 24 * 60 * 60,
        sameSite: 'lax'
      });

      // Configure consent for all tracking systems
      this.configureConsent(preferences);

      this.hideCookieBanner();

      // Emit event for other components to react
      this.$root.$emit('cookies-accepted', preferences);

      console.log('[Cookie Consent] All cookies accepted:', preferences);
    },

    onCookieBannerRejected(preferences) {
      const cookies = new Cookies();

      // Save to cookies (not session) for persistence
      cookies.set('cookie_accepted', true, {
        path: '/',
        maxAge: 6 * 30 * 24 * 60 * 60, // 1 year
        sameSite: 'lax'
      });
      cookies.set('cookie_preferences', preferences, {
        path: '/',
        maxAge: 6 * 30 * 24 * 60 * 60,
        sameSite: 'lax'
      });

      // Configure consent for all tracking systems
      this.configureConsent(preferences);

      this.hideCookieBanner();

      // Emit event for other components to react
      this.$root.$emit('cookies-rejected', preferences);

      console.log('[Cookie Consent] Optional cookies rejected:', preferences);
    },

    onCookieBannerCustomize() {
      this.showCookieCustomizationModal();
    },
    tinycolor,
    // nuova possibilità di rendering dinamico dei componenti basati sulla ricerca di un ID
    renderComponentInDiv(component, divId) {
      const div = document.getElementById(divId);
      if (div) {
        new Vue({
          parent: this,
          render: h => h(component)
        }).$mount(`#${divId}`);
      } else {
        // console.warn(`${divId} not found.`);
      }
    }
  },
  computed: {
    ...mapState({
      isBrowser: state => state.app.isBrowser,
      network: state => state['booking-networks'].getBookingNetworksRequest.data,
    }),
    isSimpleView() {
      return this.network.property_view == this.$const('property_view', 'SIMPLE');
    },
    isShowChildren() {
      return !!this.network.is_search_show_children;
    },
    isShowRooms() {
      return !!this.network.is_search_show_rooms;
    },
    isSingleProperty() {
      return !!this.network.single_property_id;
    },
    networkConfig() {
      if (!this.network.config) return {};
      
      return JSON.parse(this.network.config)
    }
  },
  mounted() {
    // esempio di render basato su ID. Si passa nome componente e poi ID tra ''
    this.renderComponentInDiv(Greview, 'google-review');
  },
  watch: {
    '$i18n.locale'(val) {
      this.$moment.locale(this.$i18n.locale);
    }
  }
}
